import { getInitialValues, requiredMessage } from "@/lib/utils"
import AuthService from "@/services/api/auth/auth"
import type { InventoryItems, InventoryPayload, TablePayload } from "@/services/api/auth/auth.interface"
import { Button } from "@mui/material"
import React, { useEffect, useMemo, useState } from "react"
import { useForm } from "react-hook-form"
import toast from "react-hot-toast"
import Table from '@/components/Table/Table'
import Modal from "@/components/Modal/Modal"
import formRenderer from "@/lib/formRenderer";
import { useSearchPagination } from "@/hooks/useSearchPagination"
import Pagination from "@/components/Table/Pagination"
import CustomHeader from "@/components/CustomHeader/CustomHeader"


interface InventoryRow {
  productId: any
  ProductCode: string
  QtyInhand: number
  QtyDistributed: number
  AddToWarehouseStock: boolean
}

const Inventory: React.FC = () => {
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loading, setLoading] = useState(true);
  const [attendanceData, setAttendanceData] = useState<InventoryRow[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [inventoryList, setInventoryList] = useState<InventoryRow[]>([]);
  const [Product, SetProductCode] = useState<any[]>([]);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [warehouseOption,setwarehouseOption]=useState([]);
  const [totalRecords,setTotalRecords] = useState<number>();
  const distributorID : any = localStorage.getItem('distributorId')? Number(localStorage.getItem('distributorId')):undefined;
  
  const handleOpenWarehouseModal =async () => {
    try {

      const data: any = {
        from: 1,
        to: 10,
        search: "",
        distributorId: distributorID
      }
      const res = await AuthService.GetWarehouseList(data)
      // setTotalRecords(res?.data?.totalRecords)
      const options = Array.isArray(res?.data?.items)
        ? res.data.items.map((item: any) => ({
          label: item.name,
          value: item.id,
        }))
        : [];
      setwarehouseOption(options);
      
    }
    catch {
      
    }
    finally {
      setLoading(false)
    }
    setModalOpen(true);
  }

  const EditOrderRow = () => {

  }

  const DeleteOrderRow = () => {

  }

  useEffect(() => {
    if (selectedRow) {
      setValue("ProductName", selectedRow.productName);
      setValue("ProductCode", selectedRow.skuCode);
      // setValue("Price",selectedRow.price)
    }
  }, [selectedRow]);

  const {
      debouncedSearch,
      search,
      setSearch,
      pageSelected,
      setPageSelected,
      rowsPerPageValue,
      setRowsPerPageValue,
    } = useSearchPagination();
  
    // Calculate pagination params
    const from = (pageSelected - 1) * rowsPerPageValue + 1;
    const to = pageSelected * rowsPerPageValue;


  const columns = useMemo(() => [
    { name: "ProductName", selector: (row: any) => row.productName },
    { name: "SKU Code", selector: (row: any) => row.skuCode },
    { name: "Quantity", selector: (row: any) => row.qty },
    { name: "Distributed Qty", selector: (row: any) => row.qtyDistributed },
    {
      name: "",
      selector: (row: any) =>
        row.qty === 0 ? (
          <span className="text-gray-400">Out of Stock</span>
        ) : (
          <Button
            variant="outlined"
            onClick={() => {
              setSelectedRow(row);
              handleOpenWarehouseModal();
            }}
          >
            Add To Warehouse
          </Button>
        )
    }
  ,
    // {
    //   name: "Action", selector: (row: any) => (
    //     <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
    //       <img
    //         src="/assets/media/Frame.png"
    //         alt="edit"
    //         className="w-5 h-5 cursor-pointer"
    //         onClick={() => EditOrderRow()}
    //       />

    //       <img
    //         src="/assets/media/Group 19026.png"
    //         alt="delete"
    //         className="w-5 h-5 cursor-pointer"
    //         onClick={() => DeleteOrderRow()}
    //       />
    //     </div>
    //   )
    // },
  ], [])

  useEffect(() => {
    fetchInventory();
  }, [pageSelected,debouncedSearch])

  const fetchInventory = async () => {
    const params = {
      from,
      to,
      search : debouncedSearch || ""
    }
    try {
      const response = await AuthService.GetInventoryList(params);
      setInventoryList(response?.data.data.items ?? []);
      setTotalRecords(response?.data.data.totalRecords);
    }
    catch (err : any){
      toast.error(err.error)
    }
  }

  const formConfig = useMemo(
    () => ({

      ProductName: {
        defaultValue: "",
        validations: { required: requiredMessage("ProductCode") },
        controlType: "input",
        label: "ProductName",
        isRequired: true,
        isDisabled: true,
      },
      ProductCode: {
        defaultValue: "",
        validations: { required: requiredMessage("ProductCode") },
        controlType: "input",
        label: "ProductCode",
        isRequired: true,
        isDisabled: true,
      },
      QtyInhand: {
        defaultValue: "",
        validations: { required: requiredMessage("Quantity") },
        controlType: "input",
        label: "Qty",
        isRequired: true,
      },
      // price: {
      //   defaultValue: "",
      //   validations: { required: requiredMessage("price") },
      //   controlType: "input",
      //   label: "price",
      //   isRequired: true,
      // },
      // DealingPrice: {
      //   defaultValue: "",
      //   validations: { required: requiredMessage("Quantity") },
      //   controlType: "input",
      //   label: "Dealing Price",
      //   isRequired: true,
      // },
      // SellingPrice: {
      //   defaultValue: "",
      //   validations: { required: requiredMessage("SellingPrice") },
      //   controlType: "input",
      //   label: "SellingPrice",
      //   isRequired: true,
      // },
      Warehouse: {
        defaultValue: "",
        validations: { required: requiredMessage("Warehouse Name") },
        controlType: "select",
        placeholder: "Select Warehouse Name",
        label: "Warehouse Name",
        isRequired: true,
        options: warehouseOption,
        isControlled: true
      },
    }),
    [warehouseOption]
  );

  const { register, handleSubmit, watch, formState, control,setValue,reset } = useForm({
    defaultValues: getInitialValues(formConfig),
    mode: "onTouched"
  })

  const onSubmit = async (values: any) => {
    const payload = {
      warehouseId: values.Warehouse,
      productId: selectedRow.productId,
      distributorId: distributorID,
      qty: values.QtyInhand,
      price: selectedRow.price,
      dealingPrice: selectedRow.dealingPrice,
      sellingPrice: selectedRow.sellingPrice,
      productName: values.ProductName,
      skuCode: values.ProductCode,
      isHold: true
    }

    try {
      const response = await AuthService.AddInventory(payload);
      if (response?.success || response?.status === 200) {
        toast.success(response?.Message || "Added to warehouse");

        setInventoryList(prev =>
          prev.map(item =>
            item.productId === selectedRow.productId
              ? { ...item, addedToWarehouse: true }
              : item
          )
        );
        setModalOpen(false);
        setSelectedRow(null);
        reset(getInitialValues(formConfig));
        fetchInventory();
      }
    }
    catch (err : any) {
      toast.error(err.error);
    }
  }

  const handleCloseModal = () => {
    reset(getInitialValues(formConfig)); 
    setSelectedRow(null);               
    setModalOpen(false);   
  };


  return (
    <div className="p-5">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">Inventory List</h2>
        {/* <Button variant="contained" color="primary" onClick={handleOpenModal}>+Add Inventory</Button> */}
        <CustomHeader
            search={search}
            setSearch={setSearch}
          />
      </div>

      <Table
        columns={columns}
        data={inventoryList}
        // progressPending={loading}
        // paginationProps={{
        //   isPagination: true,
        //   totalCount: totalRecords,
        //   pageSelected: page,
        //   setPageSelected: setPage,
        //   rowsPerPageValue: rowsPerPage,
        //   setRowsPerPageValue: setRowsPerPage,
        //   // loading
        // }}
      />
      <Pagination
        isPagination={true}
        totalCount={totalRecords ?? 0}
        pageSelected={pageSelected}
        setPageSelected={setPageSelected}
        rowsPerPageValue={rowsPerPageValue}
        setRowsPerPageValue={setRowsPerPageValue}
        customRowsPerPage={true}
      />

      <Modal
        modalOpen={modalOpen}
        closeModal={handleCloseModal}
        heading="Add To Warehouse"
        width="500px"
        saveButtonText="Submit"
        onSave={handleSubmit(onSubmit)}
        isSubmitting={formState.isSubmitting}
        >

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className= "grid grid-cols-2 gap-3">
          {formRenderer(formConfig, formState, register, control)}
          </div>
        </form>

      </Modal>

    </div>
  )

}

export default Inventory